
const digest = '69235c13a2a0dfbc7b8531347f751f409971dabaaebd70ddcc9d82e64183602b';
const classes = {"wrapper":"_wrapper_1yxo2_1","backdrop":"_backdrop_1yxo2_1","sidebar":"_sidebar_1yxo2_10","header":"_header_1yxo2_21","title":"_title_1yxo2_29","closeButton":"_closeButton_1yxo2_34","body":"_body_1yxo2_37","content":"_content_1yxo2_40"};
const css = `._wrapper_1yxo2_1 ._backdrop_1yxo2_1 {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1049;
}
._wrapper_1yxo2_1 ._sidebar_1yxo2_10 {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 415px;
  background-color: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
}
._wrapper_1yxo2_1 ._sidebar_1yxo2_10 ._header_1yxo2_21 {
  background-color: #f2f4f7;
  display: flex;
  align-items: center;
  padding: 19px;
  justify-content: space-between;
  border-bottom: 1px solid #1d65d8;
}
._wrapper_1yxo2_1 ._sidebar_1yxo2_10 ._header_1yxo2_21 ._title_1yxo2_29 {
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}
._wrapper_1yxo2_1 ._sidebar_1yxo2_10 ._header_1yxo2_21 ._closeButton_1yxo2_34 {
  cursor: pointer;
}
._wrapper_1yxo2_1 ._sidebar_1yxo2_10 ._body_1yxo2_37 {
  flex: 1;
}
._wrapper_1yxo2_1 ._sidebar_1yxo2_10 ._body_1yxo2_37 ._content_1yxo2_40 {
  height: calc(100vh - 100px);
  overflow: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  